$(document).ready(function () {
  // ____________ HEAD
  window.jQuery = $;

  // ____________ dotdotdot
  function dotF() {
    $('.news-item--block .title').each(
        function () {
          $(this).dotdotdot({
            ellipsis: '\u2026',
            truncate: 'word',
            watch: 'window',
          });
        });
    $('.news-item--block .text').each(
        function () {
          $(this).dotdotdot({
            ellipsis: '\u2026',
            truncate: 'word',
            watch: 'window',
          });
        });
    $('.dot-wrapper').each(
        function () {
          $(this).dotdotdot({
            ellipsis: '...',
            wrap: 'letter',
            fallbackToLetter: 'letter',
            after: null,
            watch: true,
            height: null,
            tolerance: 0,
          });
        });
  }

  dotF();

  $(window).resize(function () {
    // ____________ dotdotdot
    dotF();

    //_____________ fix on risize
    $('.scrollBox').height('auto');
  });

  // ____________ customScrollbar
  function customScroll() {
    if ($('.horizontal1').length > 0) {
      wellScroller(document.querySelector('.horizontal1'), {
        axis: 'x',
        wheelSpeed: '140'
      });
    }

    if ($('.horizontal2').length > 0) {
      wellScroller(document.querySelector('.horizontal2'), {
        axis: 'x',
        wheelSpeed: '140'
      });
    }
  }

  if (window.matchMedia("(min-width: 768px)").matches) {
    customScroll();
  }
  $(window).resize(function () {
    if (window.matchMedia("(min-width: 768px)").matches) {
      customScroll();
    }
  });

  // ____________ add-remove-user-click___form_ER
  (function () {
    let counterID = 0;
    $('.add-user-btn').on('click', function (e) {
      e.preventDefault();

      counterID++;
      counterID = counterID++;

      let template_form_ER =
          '<li class="add-remove-user--item reg-participant" data-number="' + counterID + '"> \
              <span class="close-btn-x"></span> \
              <div class="remove-user-btn-wrapper"> \
                  <a class="remove-user-btn-q"> \
                      Teilnehmer <span>&nbsp;entfernen</span> \
                   </a> \
                  <a class="remove-user-btn-d"> \
                      Teilnehmer entfernen \
                  </a> \
              </div> \
              <div class="remove-user-text-warning"> \
                  <p> \
                    Damit entfernen Sie den weiteren Teilnehmer und machen sämtliche <br> \
                    EIngaben rückgängig. \
                  </p> \
                  <p> \
                    Wollen Sie fortfahren? \
                  </p> \
              </div>\
                    <div class="add-remove-user--item-content form-section"> \
                        <div class="form-wrapper"> \
                            <form class="form form-style validate-form participant-form" action="#"> \
                                <div class="col col1"> \
                                  <div class="form-group form-item"> \
                                      <input type="text" class="form-control field participant-title" data-type="title" name="form_ER_title' + counterID + '" id="form_ER_title' + counterID + '"  placeholder="" value=""> \
                          <label for="form_ER_title' + counterID + '">Titel</label> \
                          <label class="error hidden">Pflichtfeld, bitte ausfüllen</label>\
                      </div>\
                      <div class="form-group form-item"> \
                          <input type="text" class="form-control field required participant-lname" data-type="lname" name="form_ER_nachname' + counterID + '" id="form_ER_nachname' + counterID + '" placeholder="" value=""> \
                          <label for="form_ER_nachname' + counterID + '">Nachname</label> \
                          <label class="error hidden">Pflichtfeld, bitte ausfüllen</label>\
                      </div> \
                    </div> \
                    <div class="col col2"> \
                        <div class="form-group form-item"> \
                            <input type="text" class="form-control field required participant-fname" data-type="fname" name="form_ER_vorname' + counterID + '" id="form_ER_vorname' + counterID + '" placeholder="" value=""> \
                            <label for="form_ER_vorname' + counterID + '">Vorname</label> \
                            <label class="error hidden">Pflichtfeld, bitte ausfüllen</label>\
                        </div> \
                        <div class="form-group form-item"> \
                            <input type="email" class="form-control field required email participant-email" data-type="email" name="form_ER_email' + counterID + '" id="form_ER_email' + counterID + '" placeholder="" value=""> \
                            <label for="form_ER_email' + counterID + '">E-mail adresse</label> \
                            <label class="error hidden">Bitte korrekte E-Mail angeben</label>\
                        </div> \
                    </div> \
                  </form> \
              </div> \
          </div> \
      </li>';

      $('.add-remove-user').append(template_form_ER);
      $('.add-remove-user').find('.add-remove-user--item:last').slideDown('fast');

      formAfterAddRemoveParticipant();

      if ($('.add-remove-user').children('.add-remove-user--item').length > 0) {
        $('.form-add-remove-user').addClass('no-empty');
      } else {
        $('.form-add-remove-user').removeClass('no-empty');
      }

      $('.remove-user-btn-q').on('click', function (e) {
        e.preventDefault();
        if ($(this).parents(".remove-user-btn-wrapper").hasClass("undeletable")){
          return false;
        }
        $('.modal-form-wrapper').addClass('remove-item');
        $(this).closest('.add-remove-user--item').addClass('select-remove');
        $(this).parent().find('.remove-user-btn-d').addClass('clicked');

        $('.modal-form-wrapper.remove-item .btn-close,.add-remove-user--item.select-remove .close-btn-x').on('click', function (e) {
          e.preventDefault();
          $('.modal-form-wrapper').removeClass('remove-item');
          $('.remove-user-btn-d').removeClass('clicked');
          $('.select-remove').removeClass('select-remove');
        });

        formAfterAddRemoveParticipant();

      });

      $('.remove-user-btn-d').on('click', function (e) {
        e.preventDefault();
        $(this).removeClass('clicked').closest('.add-remove-user--item').removeClass('select-remove').remove();
        $('.modal-form-wrapper').removeClass('remove-item');
        if ($('.add-remove-user').children('.add-remove-user--item').length <= 0) {
          $('.form-add-remove-user').removeClass('no-empty');
        } else {
          $('.form-add-remove-user').addClass('no-empty');
        }

        formAfterAddRemoveParticipant();

      });

    });
  })();

  // ____________ next-tab--next-btn
  $('.hidden-content .tab_content .btn-next').on('click', function (e) {
    e.preventDefault();
    $(this)
        .closest('.hidden-content')
        .find('.tabs-heading-item a.active').removeClass('active').addClass('hide-flag')
        .closest('.tabs-heading-item')
        .next()
        .find('a').addClass('active');
    $('.tab_content').addClass('hideTabContent').removeClass('showTabContent');
    $(this)
        .closest('.tab_content')
        .removeClass('showTabContent').addClass('hideTabContent')
        .next()
        .addClass('showTabContent').removeClass('hideTabContent');
  });

  // ____________ next-prev--close-form
  $('.step .next-form').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.step').removeClass('active')
        .next('.step').addClass('active');
  });
  $('.step .prev-form').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.step').removeClass('active')
        .prev('.step').addClass('active');
  });
  $('.modal-form-wrapper.full-form .btn-close').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.modal-form-wrapper').slideUp(300);
    $('.modal-form-wrapper--bg').slideUp(300);
  });


  // ____________ toggle-toggle-select-block___form_ER-click
  $('.line-item--ttl.toggle-select-block').on('click', function (e) {
    e.preventDefault();

    let tabs = $('.hidden-content .tabs');
    if ($(this).closest('.line-item--cont-wrap').find(tabs).length > 0) {
      let $active_f, $content_f, $links_f = $(this).closest('.line-item--cont-wrap').find('.tabs a.active');
      $active_f = $($links_f.filter('[href="' + location.hash + '"]')[0] || $links_f[0]);
      $content_f = $($active_f[0].hash);
      $content_f.addClass('showTabContent').removeClass('hideTabContent');
    }

    $('.line-item--ttl.toggle-select-block')
        .not($(this)).removeClass('active');
    $('.hidden-content-wrapper')
        .not($(this).closest('.line-item--cont-wrap').find('.hidden-content-wrapper'))
        .slideUp(300);
    $('.hidden-content')
        .not($(this).closest('.line-item--cont-wrap').find('.hidden-content'))
        .removeClass('active');
    $(this)
        .toggleClass('active hide-flag')
        .closest('.line-item--cont-wrap').find('.hidden-content-wrapper')
        .slideToggle(300)
        .find('.hidden-content').toggleClass('active');

    // $('.line-form-wrapper').height('auto');

    // $(this).closest('.line-form-wrapper').height('auto');

    // if ($(this).closest('.line-item--cont-wrap').find('.hidden-content.active').outerHeight(true) >=
    //     $(this).closest('.line-form-wrapper').outerHeight(true) + $(this).outerHeight(true) + 20) {
    //   $(this).closest('.line-form-wrapper').height($(this).closest('.line-item--cont-wrap').find('.hidden-content.active').outerHeight(true) +
    //       $(this).outerHeight(true) + 20);
    // }

  });

  $(document).mouseup(function (e) {
    let div = $('.line-item--ttl.toggle-select-block'),
        divContent = $('.hidden-content-wrapper');
    if (!div.is(e.target)
        && div.has(e.target).length === 0
        && !divContent.is(e.target)
        && divContent.has(e.target).length === 0) {
      $('.line-item--ttl.toggle-select-block')
          .removeClass('active');
      $('.hidden-content-wrapper')
          .slideUp(300);
      $('.hidden-content')
          .removeClass('active');
      // $('.line-form-wrapper')
      //     .height('auto');
    }
  });

  // ____________ form-sum
  function formSum() {
    let prise = $('.line-item--content .prise .p-num'),
        sum = 0,
        sumLayout = $('.total-for-line-form .total .sum');
    prise.each(
        function () {
          sum = sum + (+($(this).text()));
        }
    );
    sumLayout.html(sum.toFixed(2));
  }

  formSum();

  // ____________ remove-item-line-form
  $('.btn-items .btn-delete:not(.remove-item-text-block .btn-items .btn-delete)').on('click', function (e) {
    e.preventDefault();

    let h = $(this).closest('.scrollBox.horizontal').outerHeight(false);

    $(this).closest('.line-form-with-ttl-wrapper').addClass('remove-item');
    $(this).closest('.scrollBox.horizontal').css({
      'height': h
    });

  });
  $('.remove-item-text-block .btn-items .btn-delete').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.line-form-with-ttl-wrapper').remove();
    formSum();
  });

  $(document).mouseup(function (e) {
    let div = $(".remove-item-text-block .btn-items .btn-delete");
    if (!div.is(e.target)
        && div.has(e.target).length === 0) {
      div.closest('.line-form-with-ttl-wrapper').removeClass('remove-item');
      $('.scrollBox.horizontal').css({
        'height': ''
      });
    }
  });


  // ____________ change-parent-label-click
  $('.change-parent-label-form .radiobox .v1').on('click', function (e) {
    $('.change-parent-label-form .radiobox label').not($(this)).removeClass('selected');
    $(this).addClass('selected')
        .closest('.line-item--content')
        .find('.text').text('Ich trage die Kosten selbst');
  });
  $('.change-parent-label-form .radiobox .v2').on('click', function (e) {
    $('.change-parent-label-form .radiobox label').not($(this)).removeClass('selected');
    $(this).addClass('selected')
        .closest('.line-item--content')
        .find('.text').text('UCB Übernimmt die Kosten');
  });

  // ____________ confirm-form--btn-wrapper-btn-click
  $('.radioblock-confirm2 label').on('click', function (e) {
    $('.confirm-form--btn-wrapper .btn').addClass('clicked');
  });
  $('.radioblock-confirm1 label').on('click', function (e) {
    $('.confirm-form--btn-wrapper .btn').removeClass('clicked');
  });


  // ____________ close-login-modal-click
  $('.modal-widget .btn-close').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.modal-wrapper-fs').slideUp(300);
    setTimeout(function f() {
      let body = $('body.no-authorized');
      body.removeClass('no-authorized');
    }, 299);
  });

  // ____________ toggle-select-list
  (function () {
    let select = $(".selectGeneral");
    select.on('click', function (e) {
      if ($(this).is(e.target)) {
        select.find('.select-list label').css({
          'display': 'flex',
        });
      }
    });

    $(document).mouseup(function (e) {
      if (!select.is(e.target)
          && select.has(e.target).length === 0) {
        select.find('.select-list label:not(.selected)').css({
          'display': 'none',
        });
      }
    });

    select.find('.select-list label').on('click', function () {
      $(this).siblings('label').css({
        'display': 'none',
      });
      $(this).addClass('selected').css({
        'display': 'flex',
      });
    });

    select.find('.select-list').on('click', function (e) {
      if ($(this).is(e.target)) {
        $(this).find('label.selected').removeClass('selected').siblings('label').css({
          'display': 'flex',
        });
      }
    });

  })();

  // ____________ toggle-profile-title-block-click
  $('.form-wrapper .ttl .decor').on('click', function (e) {
    e.preventDefault();
    let ttlHelpWidth = $(this).closest('.ttl-help').width();

    $(document).mouseup(function (e) {
      let div = $(".form-wrapper .ttl .modal-ttl-title-block");
      if (!div.is(e.target)
          && div.has(e.target).length === 0
          && !$('.form-wrapper .ttl .decor').is(e.target)) {
        div.slideUp(300);
        $('.form-wrapper .ttl .decor').removeClass('active');
      }
    });

    if (window.matchMedia("(max-width: 767px)").matches) {
      $(this).addClass('active').siblings('.modal-ttl-title-block').css({
        'left': -(ttlHelpWidth - '36'),
        'right': '0',
        'top': '30px',
      }).slideDown(300);
    } else {
      $(this).addClass('active').siblings('.modal-ttl-title-block').slideDown(300);
    }
  });

  // ____________ transport-select-click
  $('.transport-select .v1').on('click', function (e) {
    $('.transport-select .radio').not($(this)).removeClass('selected');
    $(this).addClass('selected')
        .closest('.col-block')
        .find('.final-destination-wrapper label').text('Ab Bahnhof:');
  });
  $('.transport-select .v2').on('click', function (e) {
    $('.transport-select .radio').not($(this)).removeClass('selected');
    $(this).addClass('selected')
        .closest('.col-block')
        .find('.final-destination-wrapper label').text('Ab Flughafen:');
  });

  // ____________ toggle-profile-title-block-click
  //$('.check-wrapper .check').on('click', function (e) {
  //  e.preventDefault();
  //  $(this).toggleClass('clicked');
  //});

  // ____________ close-mail-modal
  $('.modal-wrapper-email').on('click', function (e) {
    if ($(this).is(e.target)) {
      $(this).hide();
    }
  });

  // ____________ toggle-profile-title-block-click
  $('.search-result--bookmark-block .search-result--bookmark-block-bookmark-link').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('clicked');
  });

  // ____________ toggle-lick-bookmark-click
  $('.icons-desktop-block--cont .img-wrap').not(".is-download").on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('clicked');
  });
  $('.img-links-section-list .link-item:not(.no-clicked-events)').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('clicked');
  });


  // ____________ login/logout-click-scroll-to-top
  $('.scrollToHeader').on('click', function (e) {
    let id = $(this).attr('data-href-scrollTo'),
        top = $(id).offset().top;
    $('body,html').animate({
      scrollTop: top
    }, 800);
  });

  // ____________ login-click
  //$('.btn-submit').on('click', function (e) {
  //  e.preventDefault();
  //  $(this).closest('.login-widget').toggleClass('authorized');
  //});
  $('.go-to-index').on('click', function (e) {
    $(this).closest('.login-widget').toggleClass('authorized');

    if (window.matchMedia("(max-width: 767px)").matches) {
      let url = $(this).attr('data-href');
      setTimeout(function(){
        document.location.href = url;
      }, 3000);
    }
    e.preventDefault();

    var login = document.querySelector('.login-widget');
    var logoLogin = document.querySelector('.logo-login');

    if(login.classList.contains('authorized')) {
      logoLogin.classList.add('login-flip');
      logoLogin.classList.remove('flip');
      logoLogin.classList.remove('animated');
      logoLogin.style.animationDelay = '1s';
    }
  });
  $('.link-item.login').hover(function () {
    let body = $('body');
    body.toggleClass('no-authorized');
  });

  

// ____________ filters-click
  $('.filters-btn').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('is-active');
    $('.hamburger').removeClass('is-active');
    $('.mobile-menu').removeClass('is-active');
    $('.filters').toggleClass('is-active');
  });
// ____________ mobile-menu-click
  $('.hamburger').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('is-active');
    $('.filters-btn').removeClass('is-active');
    $('.filters').removeClass('is-active');
    $('.mobile-menu').toggleClass('is-active');
  });

  // ____________ mobile filters btn
  /*
  $('.filter-btn').not('.filters-tabs--list-item-text').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('is-active');
  });
  */
  // ____________ widget-search-click
  $('.search .icon-wrapper').on('click', function (e) {
    e.preventDefault();
    $('.hamburger').addClass('is-active');
    $('.mobile-menu').addClass('is-active');
    $('#mobile-menu-search').focus();
  });

  // ____________ desktop-heading-open-click
  $('.desktop-nav-link').on('click', function (e) {
    e.preventDefault();
  });

  $('#nav-poll').click(
      function () {
        if (window.matchMedia("(max-width: 1024px)").matches) {
          $('.header-container').addClass('menu-is-open--tablet');
        }
        $('.modal-nav-block').removeClass('is-active');
        $('.desktop-nav-link .icon-wrapper').removeClass('is-active');
        $(this).find('.icon-wrapper').toggleClass('is-active');
        $('.nav-poll-block').toggleClass('is-active');
        $('.nav-profile-block').addClass('active');
      });

  $('#nav-news').click(
      function () {
        if (window.matchMedia("(max-width: 1024px)").matches) {
          $('.header-container').addClass('menu-is-open--tablet');
        }
        $('.modal-nav-block').removeClass('is-active');
        $('.desktop-nav-link .icon-wrapper').removeClass('is-active');
        $(this).find('.icon-wrapper').toggleClass('is-active');
        $('.nav-news-block').toggleClass('is-active');
        $('.nav-profile-block').addClass('active');
      });

  $('#nav-contact').click(
      function () {
        if (window.matchMedia("(max-width: 1024px)").matches) {
          $('.header-container').addClass('menu-is-open--tablet');
        }
        $('.modal-nav-block').removeClass('is-active');
        $('.desktop-nav-link .icon-wrapper').removeClass('is-active');
        $(this).find('.icon-wrapper').toggleClass('is-active');
        $('.nav-contact-block').toggleClass('is-active');
        $('.nav-profile-block').addClass('active');
      });

  $('#nav-search').click(
      function () {
        if (window.matchMedia("(max-width: 1024px)").matches) {
          $('.header-container').addClass('menu-is-open--tablet');
        }
        $('.modal-nav-block').removeClass('is-active');
        $('.desktop-nav-link .icon-wrapper').removeClass('is-active');
        $(this).find('.icon-wrapper').toggleClass('is-active');
        $('.nav-search-block').toggleClass('is-active');
        $('.nav-profile-block').addClass('active');
      });

  $('#nav-profile').click(
      function () {
        if (window.matchMedia("(max-width: 1024px)").matches) {
          $('.header-container').addClass('menu-is-open--tablet');
        }
        $('.modal-nav-block').removeClass('is-active');
        $('.desktop-nav-link .icon-wrapper').removeClass('is-active');
        $(this).find('.icon-wrapper').toggleClass('is-active');
        $('.nav-profile-block').toggleClass('is-active');
        $('.nav-profile-block').addClass('active');
      });

  $('.modal-nav-block').hover(
      function () {
      },
      function () {
        if (window.matchMedia("(max-width: 1024px)").matches) {
          $('.header-container').removeClass('menu-is-open--tablet');
        }
        $(this).removeClass('is-active');
        $('.desktop-nav-link .icon-wrapper').removeClass('is-active');
      });

  $('.modal-nav-block .btn-close').on('click', function (e) {
    e.preventDefault();
    if (window.matchMedia("(max-width: 1024px)").matches) {
      $('.header-container').removeClass('menu-is-open--tablet');
    }
    $(this).closest('.modal-nav-block').toggleClass('is-active');
    $('.desktop-nav-link .icon-wrapper').removeClass('is-active');

    if (!($('.nav-profile-block').hasClass('active'))) {
      $('.nav-profile-block').addClass('active');
      $(this).closest('.modal-nav-block').toggleClass('is-active');
      $('.nav-profile .icon-wrapper').toggleClass('is-active');
    }

  });

  // ____________ desktop add news btn
  /**
  $('.news-item-btn-add-to').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('is-active');
  }); 
  **/

  $('.news-item-btn-add-to-therapein').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('is-active');
  });

  // ____________ modal profile toggle class
  $('.login-btn').hover(function () {
    $(this).closest('.nav-profile-block').toggleClass('active');
  });
  $('.accordion-section-content .login-btn').click(function (e) {
    e.preventDefault();
    $('body').css({ cursor: "pointer" }).bind("click ", function (e) {
      let div = $('.accordion-section-content .login-btn');
      if (!div.is(e.target)
          && div.has(e.target).length === 0) {
        $('.accordion-section-content .login-btn').removeClass('active')
            .closest('.accordion-section')
            .removeClass('exit')
            .closest('.accordion-wrapper')
            .removeClass('no-clicked');
        $('body').css({ cursor: "default" });  
      }
    });
    $(this).addClass('active')
        .closest('.accordion-section')
        .addClass('exit')
        .closest('.accordion-wrapper')
        .addClass('no-clicked');
  });


  // ____________ desktop nav calc

  /*
  if ($('.nav-news-block').length) {
    let notificationItemServices = $('.items-wrapper-services .dot-wrapper--link.is-notification'),
        notificationItemHeaderSrvices = $('.for-nav-news .item-services .modal-nav-block--list-item-text'),

        notificationItemWissen = $('.items-wrapper-wissen .dot-wrapper--link.is-notification'),
        notificationItemHeaderWissen = $('.for-nav-news .item-wissen .modal-nav-block--list-item-text'),

        notificationItemEvents = $('.items-wrapper-events .dot-wrapper--link.is-notification'),
        notificationItemHeaderEvents = $('.for-nav-news .item-events .modal-nav-block--list-item-text'),

        notificationItemMeineThemen = $('.items-wrapper-meine-themen .dot-wrapper--link.is-notification'),
        notificationItemHeaderMeineThemen = $('.for-nav-news .item-meine-themen .modal-nav-block--list-item-text'),

        notificationSection = $('.desktop-nav-link.nav-news .icon-wrapper'),

        counterServices = notificationItemServices.length,
        counterWissen = notificationItemWissen.length,
        counterEvents = notificationItemEvents.length,
        counterMeineThemen = notificationItemMeineThemen.length,

        total = counterServices + counterWissen + counterEvents + counterMeineThemen;

    notificationItemHeaderSrvices.attr('data-content-counter-services', counterServices);
    notificationItemHeaderWissen.attr('data-content-counter-wissen', counterWissen);
    notificationItemHeaderEvents.attr('data-content-counter-events', counterEvents);
    notificationItemHeaderMeineThemen.attr('data-content-counter-meine-themen', counterMeineThemen);

    notificationSection.attr('data-content-counter', total);


  $('.for-nav-news .item-services .modal-nav-block--list-item-text').attr('data-content-counter-services', counterServices);
  $('.for-nav-news .item-wissen .modal-nav-block--list-item-text').attr('data-content-counter-wissen', counterWissen);
  $('.for-nav-news .item-events .modal-nav-block--list-item-text').attr('data-content-counter-events', counterEvents);
  $('.for-nav-news .item-meine-themen .modal-nav-block--list-item-text').attr('data-content-counter-meine-themen', counterMeineThemen);

  if (counterServices === 0 || '') {
    $('.for-nav-news .item-services .modal-nav-block--list-item-text').addClass('empty');
  }
  if (counterWissen === 0 || '') {
    $('.for-nav-news .item-wissen .modal-nav-block--list-item-text').addClass('empty');
  }
  if (counterEvents === 0 || '') {
    $('.for-nav-news .item-events .modal-nav-block--list-item-text').addClass('empty');
  }
  if (counterMeineThemen === 0 || '') {
    $('.for-nav-news .item-meine-themen .modal-nav-block--list-item-text').addClass('empty');
  }
  */


/****
// ____________ background image object
  let bgImgObj = {
    user1: {
      id: 1,
      name: 'Anna',
      // bgImgSrcMobile: 'http://via.placeholder.com/135x208',
      // bgImgSrcDesktop: 'http://via.placeholder.com/534x760',
      bgImgSrc: 'assets/images/nonoptimised/ucb_img-placeholder/1440x760_Start/sales.png',
    }
  };

// ____________ matchMedia
  if (window.matchMedia("(max-width: 767px)").matches) {
    // ____________ background image set mobile
    $('.main-widget--bg-img').css({
      'background': 'transparent url("' + bgImgObj.user1.bgImgSrc + '") right bottom no-repeat',
      'background-size': 'contain'
    });

  } else {
    // ____________ background image set desktop
    $('.main-widget--bg-img').css({
      'background': 'transparent url("' + bgImgObj.user1.bgImgSrc + '") right bottom no-repeat',
      'background-size': 'contain'
    });
    $('.nav-contact-block .img-block').css({
      'background': 'transparent url("' + bgImgObj.user1.bgImgSrc + '") right bottom no-repeat',
      'background-size': 'contain'
    });

  }

  $(window).resize(function () {
    if (window.matchMedia("(max-width: 767px)").matches) {
      // ____________ background image set mobile
      $('.main-widget--bg-img').css({
        'background': 'transparent url("' + bgImgObj.user1.bgImgSrc + '") right bottom no-repeat',
        'background-size': 'contain'
      });
    } else {
      // ____________ background image set desktop
      $('.main-widget--bg-img').css({
        'background': 'transparent url("' + bgImgObj.user1.bgImgSrc + '") right bottom no-repeat',
        'background-size': 'contain'
      });
    }
  });
****/

  // ____________ sticky
  function stickyFunc(x) {

    let check = $('.sticky-element');
    if (x.matches && check) {
      let StickyElement = function (node) {
        let doc = $(document),
            fixed = false,
            anchor = node.find('.sticky-anchor'),
            content = node.find('.sticky-content');

        let onScroll = function () {
          let docTop = doc.scrollTop(),
              anchorTop = anchor.offset().top;

          if (docTop - 1 > anchorTop) {
            if (!fixed) {
              anchor.height(content.outerHeight(true));
              content.addClass('fixed');
              fixed = true;
            }
          } else {
            if (fixed) {
              anchor.height(0);
              content.removeClass('fixed');
              fixed = false;
            }
          }
        };
        $(window).on('scroll', onScroll);
        $(window).scroll();
      };
      if ($('#sticky-header').length) {
        new StickyElement($('#sticky-header'));
      }
      if ($('#sticky-desktop-filters-sections').length) {
        new StickyElement($('#sticky-desktop-filters-sections'));
      }

      function stickyBtn() {
        let headerOff = 60,
            stickyIconBlock = $('.icons-desktop-block--cont-wrapper'),
            stickyItem = $('.icons-desktop-block--cont'),
            stickyEnd = $('.thematic-section-wrapper');

        if (stickyIconBlock.length) {

          $(window).on('scroll', function () {
            if (window.matchMedia('(min-width: 1320px)').matches) {
              let winOff = $(window).scrollTop();
              //console.log($('.thematic-section-wrapper').offset().top - winOff);
              if (headerOff >= stickyIconBlock.offset().top - winOff
                  && stickyEnd.offset().top - winOff > stickyItem.outerHeight(true) + 80) {
                stickyItem.addClass('offset');
              }
              else if (headerOff < stickyIconBlock.offset().top - winOff
                  || stickyEnd.offset().top - winOff < stickyItem.outerHeight(true) + 80) {
                stickyItem.removeClass('offset');
              }
            } else {
              stickyItem.removeClass('offset');
            }
          }).trigger("resize");

        }
      }
      stickyBtn();

      function desktopFP() {
        let page = $('.desktop-filters-page'),
            header = $('#sticky-header');

        if (page.length) {
          $(window).on('scroll', function () {
            if (window.matchMedia('(min-width: 768px)').matches) {
              let winOff = $(window).scrollTop();
              if (header.offset().top - winOff <= (-600)) {
                page.addClass('no-header');
              } else if (header.offset().top - winOff == 0) {
                page.removeClass('no-header');
              }
            }
          });
        }

      }

      desktopFP();

    }
  }

  (function () {
    let x = window.matchMedia("(min-width: 0px)");
    stickyFunc(x);
    x.addListener(stickyFunc);
  })();

  // ____________ tabs
  $('ul.tabs').not('.pub-list').each(function () {
    let $active, $content, $links = $(this).find('a');
    $active = $($links.filter('[href="' + location.hash + '"]')[0] || $links[0]);
    $active.addClass('active');
    $content = $($active[0].hash);
    $links.not($active).each(function () {
      $(this).addClass('hide-flag');
      $(this.hash).addClass('hideTabContent');
    });
    $active.each(function () {
      $(this.hash).addClass('showTabContent');
    });
    $(this).on('click', 'a', function (e) {
      $links.removeClass('active');
      $('.tab_content').addClass('hideTabContent').removeClass('showTabContent');
      $content.addClass('hideTabContent').removeClass('showTabContent');
      $active = $(this);
      $content = $(this.hash);
      $active.addClass('active').toggleClass('hide-flag');
      $active.closest('li').siblings().find('> a').addClass('hide-flag');
      $content.addClass('showTabContent').removeClass('hideTabContent');
      if ($active.hasClass('hide-flag') && $content.hasClass('showTabContent')) {
        $content.toggleClass('showTabContent').toggleClass('hideTabContent');
        $('.desktop-filters-sort--list-item-text').removeClass('active').addClass('no-click');
      } else {
        $('.desktop-filters-sort--list-item-text').removeClass('no-click');
        $('.desktop-filters-sort--list-item-text.clicked').addClass('active');
      }
      e.preventDefault();
    });
  });

  // ____________ accordion
  function close_accordion_section() {
    $('.accordion .accordion-section-title').removeClass('is-active');
    $('.accordion .accordion-section-content').slideUp(300).removeClass('open');
  }

  $('.accordion-section-title').click(function (e) {
    let currentAttrValue = $(this).attr('href');

    if ($(e.target).is('.is-active')) {

      if (!($(this).closest('.accordion').hasClass('no-close-all'))) {
        close_accordion_section();
      } else {
        $(this).toggleClass('is-active');
        $('.accordion ' + currentAttrValue).slideToggle(300).toggleClass('open');
      }

    } else if ($(this).closest('.accordion').hasClass('no-close-all')) {

      $(this).toggleClass('is-active');
      $('.accordion ' + currentAttrValue).slideToggle(300).toggleClass('open');

    } else {
      close_accordion_section();

      $(this).addClass('is-active');
      $('.accordion ' + currentAttrValue).slideDown(300).addClass('open');
    }
    e.preventDefault();
  });



  // ____________ slick-slider
  //console.log();
  if (typeof(gSearchSectionSwitch) != "undefined") gSearchSectionSwitch = $('.slick-section-all-search-section');
  let sliderThematicSection = $('.slick-section-all-thematic-section'),      
      sliderEvents = $('.events-slider'),
      sliderFor = $('.events-slider-for'),
      sliderNav = $('.events-slider-nav'),
      sliderNavItemsContent = $('.events-slider-nav-content a');


  sliderThematicSection.slick({
    fade: false,
    arrows: false,
    dots: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true,    
    adaptiveHeight: true,
    initialSlide: typeof(tsMap) !== 'undefined' ? tsMap[$(".slick-section-all-thematic-section").attr("data-initial-slide")] : 0 
  }).on("afterChange", typeof(thematicSectionChange) !== 'undefined' ? thematicSectionChange : function(){});


  try {
    if (typeof(gSearchSectionSwitch) != "undefined"){
      gSearchSectionSwitch.slick({
        fade: false,
        arrows: false,
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true,    
        adaptiveHeight: true
      }).on("afterChange", typeof(thematicSectionChange) !== 'undefined' ? thematicSectionChange : function(){});    
    }
  } catch(err) { }


  sliderEvents.slick({
    arrows: true,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: true,
        }
      }
    ]
  });

  sliderFor.slick({
    arrows: true,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
        }
      }
    ]
  });



  sliderFor.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    sliderNavItemsContent.each(function (index) {
      if (nextSlide == $(this).attr('data-index') - 1) {
        sliderNavItemsContent.removeClass('active');
        $(this).addClass('active');
      }
    });
  });

  sliderNav.slick({
    arrows: true,
    dots: false,
    infinite: true,
  });

  sliderNavItemsContent.click(function (e) {
    e.preventDefault();
    sliderNavItemsContent.removeClass('active');
    $(this).addClass('active');
    let slideIndex = $(this).attr('data-index') - 1;
    sliderFor.slick('slickGoTo', slideIndex, true);
  });

  //sliderFor.slick();


// ____________ dotdotdot
  $('.news-item--block .title').each(
      function () {
        $(this).dotdotdot({
          ellipsis: '\u2026',
          truncate: 'word',
          watch: 'window',
        });
      });

  // ____________ filters
/***  
  $('.desktop-filters-sort--list-item-text').on('click', function (e) {
    e.preventDefault();
    if (!$(this).hasClass('clicked')) {
      $(this).addClass('clicked active sort-down');
      $('.desktop-filters-sort--list-item-text').not(this).removeClass('active clicked sort-down');
    } else {
      $('.desktop-filters-sort--list-item-text').removeClass('clicked sort-down');
    }

    function filterSort(e) {
      // sort-up
      if ($('.desktop-filters-sort--list-item-text.sort-filter1').hasClass('active')) {
        $('.filters-list').addClass('flex-wrap-row-revers-wrap flex-wrapper-fe');
        $('.filters-list li').addClass('displayNone').removeClass('displayFlex');
        $('.filters-list .sort-from1').addClass('displayFlex').removeClass('displayNone');
      } else if ($('.desktop-filters-sort--list-item-text.sort-filter2').hasClass('active')) {
        $('.filters-list').addClass('flex-wrap-row-revers-wrap flex-wrapper-fe');
        $('.filters-list li').addClass('displayNone').removeClass('displayFlex');
        $('.filters-list .sort-from2').addClass('displayFlex').removeClass('displayNone');
      } else if ($('.desktop-filters-sort--list-item-text.sort-filter3').hasClass('active')) {
        $('.filters-list').addClass('flex-wrap-row-revers-wrap flex-wrapper-fe');
        $('.filters-list li').addClass('displayNone').removeClass('displayFlex');
        $('.filters-list .sort-from3').addClass('displayFlex').removeClass('displayNone');
      }
      // sort-down
      if ($('.desktop-filters-sort--list-item-text.sort-filter1.sort-down').hasClass('active')) {
        $('.filters-list').removeClass('flex-wrap-row-revers-wrap flex-wrapper-fe');
        $('.filters-list li').addClass('displayNone').removeClass('displayFlex');
        $('.filters-list .sort-from1').addClass('displayFlex').removeClass('displayNone');
      } else if ($('.desktop-filters-sort--list-item-text.sort-filter2.sort-down').hasClass('active')) {
        $('.filters-list').removeClass('flex-wrap-row-revers-wrap flex-wrapper-fe');
        $('.filters-list li').addClass('displayNone').removeClass('displayFlex');
        $('.filters-list .sort-from2').addClass('displayFlex').removeClass('displayNone');
      } else if ($('.desktop-filters-sort--list-item-text.sort-filter3.sort-down').hasClass('active')) {
        $('.filters-list').removeClass('flex-wrap-row-revers-wrap flex-wrapper-fe');
        $('.filters-list li').addClass('displayNone').removeClass('displayFlex');
        $('.filters-list .sort-from3').addClass('displayFlex').removeClass('displayNone');
      }

    }

    //filterSort();
***/



  function toggleHeaderLogo() {
    var logoShow = document.querySelector('.logo__show');
    var logoUsual = document.querySelector('.logo__usual');

    if ( window.innerWidth > 767) {
        if (logoShow && logoUsual) {
            var scroll = window.pageYOffset;
            if (scroll > 20) {
                logoShow.classList.add('hidden');
                logoUsual.classList.remove('hidden');
            } else {
                logoShow.classList.remove('hidden');
                logoUsual.classList.add('hidden');
            }
      }
    } else {
        if (logoUsual) {
            logoUsual.classList.add('hidden');
        }
    }
  }

  if (document.getElementById('profile-page')) {
    startAnimation();
  }

  document.addEventListener('scroll', toggleHeaderLogo);

  toggleHeaderLogo();
  restartAnimation();

  var actions = ['click', 'scroll', 'mouseover', 'keyup'];
  for (var i = 0; i < actions.length; i++) {
    document.addEventListener(actions[i], restartAnimation);
  }
});

window.startAnimation = function() {
  var logo = document.querySelector('.logo__show-img');
  if (logo) {
    var cl = logo.classList;
    var animationDuration = 1000;
    var pause = 1000;

    if (window.matchMedia("(max-width: 767px)").matches) {
        if (cl.contains('logo-down-animated-reverse') || !cl.contains('logo-down-animated')) {
        cl.remove('logo-down-animated-reverse');
        cl.add('logo-down-animated');
        setTimeout(function() {
            cl.remove('logo-down-animated');
            cl.add('logo-down-animated-reverse');
            restartAnimation();
        }, animationDuration + pause);
        }
    } else {    
        if (cl.contains('logo-animated-reverse') || !cl.contains('logo-animated')) {
          cl.remove('logo-animated-reverse');
          cl.add('logo-animated');
          setTimeout(function() {
              cl.remove('logo-animated');
              cl.add('logo-animated-reverse');
              restartAnimation();
          }, animationDuration + pause);
        }
    }
  }
}

var interval;

window.restartAnimation = function() {
  clearInterval(interval);
  interval = setInterval(startAnimation, 7000);
}

window.stopAnimation = function() {
  clearInterval(interval);
}

function sortList() {
  var list = document.querySelectorAll('.logo__list_categories-box div');
  var usedCategories = [];
  for (var i = 0; i < list.length; i++) {
    const elem = list[i];
    const category = elem.getAttribute('data-category')
    if (usedCategories.indexOf(category) === -1) {
        usedCategories.push(category)
    } else {
        elem.classList.add('used');
    }
  }
}

sortList();



// WEBPACK FOOTER //
// ./src/assets/js/app/indexPage.js